export const NumberLessBRL = (text: string) => {
    if (text === null || text === undefined) {
        text = '0.00';
    }

    const numb = text.trim()
        .replace(/^\D+/g, '')
        .replace(/\./g, '*')
        .replace(/\,/g, '.')
        .replace(/\*/g, ',')
        .replace(/\B(?=(\d{3})+(?!\d))/g, ".")
        .split(',');

    return numb[0];
}

export const NumberConvert = (text: string) => {

    if (text === null || text === undefined || text === '') {
        text = '0.00';
    }

    const money = text.replace(/\$/g, '')
        .replace(/\,/g, '');

    return parseFloat(money);
}


/**
 * Compara a Variação Percentual
 * 
 * O percentual se dá pela fórmula:
 *      (valorAtual - valorAntigo)/valorAntigo*100
 * Conforme exemplo: valorAtual = 10000 e valorAntigo = 8000
 *      O crescimento de 2000 representa 25% em relação ao valorAntigo
 */
export const NumberCompareVP = (a: number, b: number) => {
    if(b == null || b === undefined || b === 0) {
        return null;
    }
    return ((a-b)/b * 100);
}

export const NumberPercent = (total: number, parte: number) => {
    if(total == null || total === undefined || total === 0) {
        return null;
    }
    return (parte * 100)/total;
}



// WEBPACK FOOTER //
// ./src/services/NumberService.tsx